"use client";

/**
 * Starts a WorkOS AuthKit password-change email for the current user.
 * Delivery is email-only (AuthKit default emails); the API does not return a
 * hosted URL to open in-app, which would double-deliver the same reset link.
 */
export const requestChangePasswordEmail = async (): Promise<string> => {
  const res = await fetch("/api/auth/change-password", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  let body: { message?: string; ok?: boolean } = {};
  try {
    body = (await res.json()) as { message?: string; ok?: boolean };
  } catch {
    // ignore parse errors
  }

  if (!res.ok) {
    throw new Error(body.message || "Failed to start password change.");
  }

  return body.message || "Check your email for a link to change your password.";
};
